import { ArsContextState, IArsActionToggleSidebar } from "../interface";

/**
 * Toggles or explicitly sets sidebar visibility.
 *
 * @param state - Current ARS context state
 * @param action - Toggle-sidebar action
 * @returns Updated state with sidebar open state changed
 */
export const arsc_toggleSidebar = <T>(
  state: ArsContextState<T>,
  action: IArsActionToggleSidebar,
): ArsContextState<T> => ({
  ...state,
  currentSidebar: {
    ...state.currentSidebar,
    isOpen: action.showSidebar ?? !state.currentSidebar.isOpen,
  },
});
